var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.746 34.7748C13.746 45.1748 18.746 50.7748 21.246 52.2748L21.246 67.7748C4.04599 58.9748 0.412659 42.1081 0.745993 34.7748C1.94599 7.57476 22.6852 0.774785 33.746 0.77478C61.2257 0.774769 68.4127 24.4414 68.246 34.7748C69.046 56.7748 53.246 66.6081 45.246 68.7748V54.2748C53.646 47.8748 55.4127 38.6081 55.246 34.7748C52.2257 17.7748 39.5793 16.7748 33.746 16.7748C19.346 16.3748 13.746 27.7748 13.746 34.7748Z",
    fill: "url(#paint0_linear_836_10)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_836_10",
    x1: 34.7257,
    y1: 34.7748,
    x2: 34.7257,
    y2: 34.2748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92C020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92C020"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingSvg);
export default __webpack_public_path__ + "static/media/LoadingSVG.cbed789a34ada53da5a62622b241d682.svg";
export { ForwardRef as ReactComponent };